import { useEffect, useState } from "react";
import chatCss from "../../styles/Dashboard Styles/chat.module.scss";
import headerCss from "../../styles/Dashboard Styles/header.module.scss";
import { IoMdArrowRoundBack } from "react-icons/io";
import { MdSend } from "react-icons/md";
import Incoming from "./Incoming.jsx";
import Outgoing from "./Outgoing.jsx";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";

function ChatArea({
  selectedUser,
  userActiveStatus,
  closeChatFunction,
  socket,
}) {
  const [chats, setChats] = useState([]);
  const [senderId, setSenderId] = useState("");
  const [newChat, setNewChat] = useState(true);

  // Receive Messages From Opposite Person
  useEffect(() => {
    socket.on(
      "getPrivateMessage",
      ({ sender, receiver, message, dateTime }) => {
        let senderId = document
          .getElementsByClassName(`${headerCss.navBar}`)[0]
          .getAttribute("id");
        let receiverId = document
          .getElementsByClassName(`${chatCss.chatContainer}`)[0]
          .getAttribute("id");

        if (sender === receiverId && receiver === senderId) {
          let msgDetail = {
            sender,
            message,
            dateTime,
          };
          setChats([...chats, msgDetail]);
        }
      }
    );
  }, [selectedUser, chats, socket]);

  // Retrive Chats

  useEffect(() => {
    async function getChats() {
      let sender = document
        .getElementsByClassName(`${headerCss.navBar}`)[0]
        .getAttribute("id");

      setSenderId(sender);

      let OPTIONS = {
        secret: "thisisasecretkeyforreactchatappnamedchatwave",
        sender,
        receiver: selectedUser._id,
      };

      let { data } = await axios.post(
        "https://chatwave-b-api.onrender.com/retriveChats",
        OPTIONS
      );

      if (data.status) {
        setChats(data.chats);
        setNewChat(false);
      } else {
        setChats([]);
        setNewChat(true);
      }
    }
    getChats();

    return () => {
      setChats([]);
    };
  }, [selectedUser, socket]);

  // Send Message To Database

  function dateTime() {
    let date = new Date().getDate();
    let month = new Date().getMonth();
    let year = new Date().getFullYear();
    let hours = new Date().getHours();
    let mins = new Date().getMinutes();

    let formattedDateTime = `${date < 10 ? "0" + date : date}/${
      month < 10 ? "0" + month : month
    }/${year} ${hours < 10 ? "0" + hours : hours}:${
      mins < 10 ? "0" + mins : mins
    }`;

    return formattedDateTime;
  }

  async function sendMessage(e) {
    if (e.key === "Enter" && e.target.value.trim() !== "") {
      let message = e.target.value;

      let sender = document
        .getElementsByClassName(`${headerCss.navBar}`)[0]
        .getAttribute("id");

      setSenderId(sender);

      let sentTime = dateTime();

      socket.emit("sendPrivateMessage", {
        sender: sender,
        receiver: selectedUser._id,
        message,
        dateTime: sentTime,
      });

      let msgDetail = {
        secret: "thisisasecretkeyforreactchatappnamedchatwave",
        sender,
        receiver: selectedUser._id,
        message,
        dateTime: sentTime,
      };

      setChats([...chats, msgDetail]);
      setNewChat(false);

      let { data } = await axios.post(
        "https://chatwave-b-api.onrender.com/sendMessage",
        msgDetail
      );

      if (!data.status) {
        toast.error(data.message, {
          duration: 2000,
          style: { fontFamily: "Poppins" },
        });
      } else {
        e.target.value = "";
      }
    }
  }

  async function sendMessageByBtn() {
    let message = document.querySelector("#outMsgInp");
    if (message.value.trim() !== "") {
      let sender = document
        .getElementsByClassName(`${headerCss.navBar}`)[0]
        .getAttribute("id");

      setSenderId(sender);

      let sentTime = dateTime();

      let msgDetail = {
        secret: "thisisasecretkeyforreactchatappnamedchatwave",
        sender,
        receiver: selectedUser._id,
        message: message.value,
        dateTime: sentTime,
      };

      socket.emit("sendPrivateMessage", {
        sender: sender,
        receiver: selectedUser._id,
        message: message.value,
        dateTime: sentTime,
      });

      setChats([...chats, msgDetail]);
      setNewChat(false);

      let { data } = await axios.post(
        "https://chatwave-b-api.onrender.com/sendMessage",
        msgDetail
      );

      if (!data.status) {
        toast.error(data.message, {
          duration: 2000,
          style: { fontFamily: "Poppins" },
        });
      } else {
        message.value = "";
      }
    }
  }

  return (
    <>
      <Toaster />
      <div className={`${chatCss.chatContainer}`} id={selectedUser._id}>
        <div className={chatCss.chatElements}>
          <div className={chatCss.header}>
            <div className={chatCss.headerLeft}>
              <IoMdArrowRoundBack onClick={closeChatFunction} />
              <div className={chatCss.profilePic}>
                <h2>{selectedUser.username[0].toUpperCase()}</h2>
              </div>
              <h2>{selectedUser.username}</h2>
              <div className={chatCss.activeStatus}>
                {userActiveStatus ? (
                  <div className={chatCss.dot}></div>
                ) : (
                  <div
                    className={chatCss.dot}
                    style={{ backgroundColor: "rgb(192, 192, 192)" }}
                  ></div>
                )}
              </div>
            </div>
          </div>

          <div className={chatCss.message}>
            {newChat ? (
              <>
                <div className={chatCss.newChat}>
                  <h3 align="center">
                    Start Conversation With {selectedUser.username}
                  </h3>
                </div>
              </>
            ) : (
              chats.map((chat, ind) => {
                if (chat.sender === senderId) {
                  return <Outgoing outgoingMessages={chat} key={ind} />;
                } else {
                  return <Incoming incomingMessages={chat} key={ind} />;
                }
              })
            )}
          </div>

          <div className={chatCss.typing}>
            <input
              type="text"
              placeholder="Type a message"
              name="message"
              id="outMsgInp"
              spellCheck="false"
              autoComplete="off"
              onKeyDown={(e) => sendMessage(e)}
            />
            <div className={chatCss.sendBtn}>
              <MdSend onClick={sendMessageByBtn} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChatArea;
